import React from "react";
import { shallowEqual } from "react-redux";
import { useUscSelector } from "../../../../../redux/store";
import { useUscLabel } from "../../../../../utils/labels";
import UscBasketItemWrapper from "../common/UscBasketItemWrapper";
import Text from "../../../../../../shared-components/toyota/styles/atoms/Text";
import Icon from "../../../../../../shared-components/toyota/styles/atoms/Icon";
import Button from "../../../../../../shared-components/toyota/styles/atoms/Button";
import { getServicesListSelector } from "../../../../../utils/externalPriceUtils";
import { financeServicesSelector } from "../../../../../utils/financeUtils";

const BasketServices = (): JSX.Element | null => {
    // TODO (UC-1209/UC-1210): Services should be retrieved from the basket, not using a selector.
    // This means that some services should be added by default already on PDP init.
    // This is a refactor that will take place when integrating the new services, until then
    // we're relying on this selector.
    const services = useUscSelector(getServicesListSelector("included"), shallowEqual);
    const financeServices = useUscSelector(financeServicesSelector, shallowEqual);
    const [titleLabel, ariaRemoveService] = useUscLabel(["uscBasketServicesTitle", "uscA11yButtonRemoveService"]);

    if (!services.length && !financeServices.length) return null;

    return (
        <div data-testid="usc-basketservices">
            <UscBasketItemWrapper title={titleLabel}>
                {services.map((service) => (
                    <li key={service.label}>
                        <Text variant="body-small-book">{service.label}</Text>
                        <span>
                            <Text variant="body-small-book" color="grey-7">
                                {service.formattedPrice}
                            </Text>
                            {!service.preSelected && (
                                <Button variant="control-grey" size="small" aria-label={ariaRemoveService}>
                                    <Icon variant="close" />
                                </Button>
                            )}
                        </span>
                    </li>
                ))}
                {financeServices.map((financeService) => (
                    <li key={financeService.key}>
                        <Text variant="body-small-book">{financeService.label}</Text>
                        <span>
                            <Text variant="body-small-book">
                                <span dangerouslySetInnerHTML={{ __html: financeService.formattedPrice }} />
                            </Text>
                            {!financeService.includedInFinance && (
                                <Button variant="control-grey" size="small" aria-label="Remove finance service">
                                    <Icon variant="close" />
                                </Button>
                            )}
                        </span>
                    </li>
                ))}
            </UscBasketItemWrapper>
        </div>
    );
};

export default BasketServices;
